/** 悬浮的我的日程, 目前仅用于canvas */
import { VFC, useContext } from 'react';
import WidgetImg from './myschedule.svg';
import './index.scss';
import type { OwnSchedules } from '@quickService/ActivitiesRegisterQueryUserSchedule';
import MyScheduleList from '../schedules';
import { Icon } from '@tencent/tea-component';
import classnames from 'classnames';
import { MyScheduleIconContext } from '../../CanvasRender';
const MyScheduleWidget: VFC<{ eventid: string; myScheduleList: OwnSchedules }> = ({
  eventid,
  myScheduleList,
}) => {
  const { myScheduleIconState, setMyScheduleIconState } = useContext(MyScheduleIconContext);
  const { show, animated } = myScheduleIconState;
  if (!myScheduleList?.length) return null;
  return (
    <div className="widget-my-schedule">
      <div className={classnames('widget-my-schedule-list', { show })}>
        <div className="widget-my-schedule-list-title">
          我的日程
          <Icon
            type="close"
            onClick={() => {
              setMyScheduleIconState({ show: false, animated: false });
            }}
          />
        </div>
        <div className="widget-my-schedule-list-content">
          <MyScheduleList
            scheduleList={myScheduleList}
            eventId={eventid}
            hideCollapse
            isMobile={true}
            isCanvasPage
          />
        </div>
      </div>
      <div className={classnames('widget-my-schedule-mask', { show })}></div>
      <img
        src={WidgetImg}
        className={classnames('widget-my-schedule-entry', {
          animated: show === false && animated === true,
        })}
        onClick={() => {
          setMyScheduleIconState({ show: !show, animated: false });
        }}
      />
    </div>
  );
};

export default MyScheduleWidget;
